import { Component, DetailEvent, Entity, registerComponent, registerSystem, System } from "aframe";


interface VideoPlayerComponent extends Component
{
	data : {
		target : Entity;
		attribute : string;
		mapProperty : string;
		colorProperty : string;
		intensityProperty : string;
		minFilterProperty : string;
		video : any;
	}
}



interface MediaEventDetail
{
	type : string;
	constraints : MediaStreamConstraints | DisplayMediaStreamConstraints;
}



registerSystem("media", {

	init(this : System & { ready : Promise<void> } )
	{
		this.ready = new Promise<void>( (y,n) =>
			window.addEventListener("click", y as any, {once:true})
		);

		const sceneEl = this.el;

		sceneEl.addEventListener("request-media-track", ((event : DetailEvent<MediaEventDetail>) =>
		{
			let promise : Promise<MediaStream>;

			const constraints = event.detail?.constraints;

			if(event.detail?.type == "display")
			{
				promise = navigator.mediaDevices.getDisplayMedia(constraints as DisplayMediaStreamConstraints);
			}
			else
			{
				promise = navigator.mediaDevices.getUserMedia(constraints as MediaStreamConstraints);
			}

			promise.then( (stream) => {

				let track : MediaStreamTrack;
				if( constraints?.video )
					track = stream.getVideoTracks()[0];
				else if( constraints?.audio )
					track = stream.getAudioTracks()[0];
				else
					track = stream.getTracks()[0];

				event.target.dispatchEvent(new CustomEvent("play-media-track", { detail : track, bubbles : true } ));
			}	);

		}) as EventListener );

		sceneEl.addEventListener("play-media-track", ((event : DetailEvent<MediaStreamTrack>) =>
		{
			const el = event.target as Entity, track = event.detail;

			if(track.kind != "video") //Don't playback entity-bound audio tracks : there's a global audio track mixed by the server.
				return;

			const player = document.createElement(track.kind) as HTMLMediaElement;
			player.srcObject = new MediaStream([track]);
			
			this.ready.then( () => player.play() );

			//Most likely video-player
			const targetAttr = track.kind + "-player";
			
			//If a child El already has the attribute, play on it
			const targetEl = (el.querySelector("[" + targetAttr + "]") || el) as Entity;
			targetEl.setAttribute(targetAttr,  { [track.kind] : player } );

		}) as EventListener)

	}

});


registerComponent("video-player", {
	schema : {
		target : { type : "selector" },
		attribute : { type : "string", default : "material" },
		mapProperty : { type : "string", default : "src" },
		colorProperty : { type : "string", default : "" },
		intensityProperty : { type : "string", default : "" },
		minFilterProperty : { type : "string", default : "minFilter" },
		video : { type : "map" }
	},
	update(this : VideoPlayerComponent)
	{
		const value : { [key:string] : any } = {};
		value[this.data.mapProperty] = this.data.video;
		if(this.data.colorProperty)
			value[this.data.colorProperty] = this.data.video ? "#FFF" : "#000";
		if(this.data.intensityProperty)
			value[this.data.intensityProperty] = this.data.video ? 1.0 : 0.0;
		// Super important : don't declare a filter that uses mipmaps
		if(this.data.minFilterProperty)
			value[this.data.minFilterProperty] = this.data.video ? 'linear' : 'linear-linear';
		(this.data.target || this.el).setAttribute(this.data.attribute, value );
	}
})